// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const venusaur: PokeData = {
  "id": 3,
  "name": "venusaur",
  "height": 20,
  "weight": 1000,
  "base_experience": 236,
  "types": [
    PokeType.GRASS,
    PokeType.POISON
  ],
  "api_moves": [
    "vine-whip",
    "tackle",
    "take-down",
    "double-edge",
    "growl",
    "leech-seed",
    "growth",
    "razor-leaf",
    "solar-beam",
    "poison-powder",
    "sleep-powder",
    "petal-dance",
    "amnesia",
    "sweet-scent",
    "synthesis",
    "worry-seed",
    "seed-bomb",
    "power-whip",
    "petal-blizzard"
  ],
  "moves": [
    "vine-whip",
    "tackle",
    "growl",
    "razor-leaf",
    "solar-beam",
    "poison-powder",
    "synthesis",
    "power-whip",
    "branch-poke",
    "aromatherapy",
    "toxic-overload",
    "poison-gas",
    "overgrowth"
  ],
  "evolution_chain": {
    "id": 1,
    "item": null,
    "species": [
      {
        "name": "bulbasaur",
        "order": 1,
        "types": [
          PokeType.GRASS,
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "ivysaur",
        "order": 2,
        "types": [
          PokeType.GRASS,
          PokeType.POISON
        ],
        "evolves_from_species_id": 1,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "venusaur",
        "order": 3,
        "types": [
          PokeType.GRASS,
          PokeType.POISON
        ],
        "evolves_from_species_id": 2,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 32,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 129,
    "speed": 120,
    "ability_power": 151
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
